module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-for-use@2x.a3b7ae03.jpg";